import { FetchError } from 'ofetch';
import type { AuthenticatedFetcher } from '@/generic/authentication';
import { Result } from '@/generic/functional';
import type { User } from '@/supporting/account/domain/User.ts';
import type { UsersRepository } from '@/supporting/account/domain/UsersRepository.ts';
import { WithoutOrganization } from '@/supporting/account/domain/WithoutOrganization.ts';
import { parseJsonToUser } from '@/supporting/account/secondary/CleanApiUserJson.ts';

const FORBIDDEN = 403;

const belongsToNoOrganization = (error: unknown): boolean =>
  error instanceof FetchError && error.status === FORBIDDEN;

export class UsersCleanApiHttp implements UsersRepository {
  readonly #fetcher: AuthenticatedFetcher;

  constructor(fetcher: AuthenticatedFetcher) {
    this.#fetcher = fetcher;
  }

  async currentUser(): Promise<Result<WithoutOrganization, User>> {
    return await this.#fetcher
      .fetch('/api/users/me', {
        method: 'GET',
      })
      .then((json) => Result.success<WithoutOrganization, User>(parseJsonToUser(json)))
      .catch((error: unknown) => {
        if (belongsToNoOrganization(error)) {
          return Result.error<WithoutOrganization, User>(WithoutOrganization);
        }
        throw error;
      });
  }
}
